<template>
  <SalesDocumentForm />
</template>

<script>
import SalesDocumentForm from '@/components/Ventas/genera_venta.vue'
export default {
  name: 'VentasView',
  components: { SalesDocumentForm }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/VentasView.vue